<template>
  <vx-card id="scheduleViewDataContainer" class="vs-con-loading__container">
    <div class="vx-row">
      <div class="vx-col md:w-1/2 sm:w-1/2 w-full" v-text="schedule.message" />
    </div>
  </vx-card>
</template>

<script>
import {EventBus} from '@/../eventbus'
import Schedule from '@/models/Schedule'

export default {
  name: 'Shared.Schedules.View',
  data () {
    return {
      schedule: {}
    }
  },
  mounted () {
    // TODO: Check why this is mounting twice.
    EventBus.$on('initViewScheduleModal', (data) => {
      this.showSchedule(data.id)
    })
  },
  methods: {
    async showSchedule (id) {
      try {
        const response = await Schedule.show({ id })
        this.schedule = response.data
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
